/*
  8888888b. 8888888  .d8888b.        d88888                   
  888   Y88b  888   d88P  Y88b      d888888                   
  888   d88P  888   888            d88P 888 88888b.  88888b.  
  8888888P"   888   888           d88P  888 888 "88b 888 "88b 
  888         888   888          d88P   888 888  888 888  888 
  888         888   Y88b  d88P  d8888888888 888 d88P 888 d88P 
  888       8888888  "Y8888P"  d88P     888 88888P"  88888P"  
                                          888      888
                                          888      888

* Copyright Manuel Valle C., AromaItaliano SA, Costa Rica
*
* jsonform.picapp.js v1.2
* Custom fields for JSONForm
*/
(function($) {
    'use strict';

    // Adds custom field types language variables
    $.extend(true, JSONForm, {
        fieldTypes: {
			bool: {
				template: '<div class="form-group jsonform-error-<%= keydash %>' +
					'<%= elt.htmlClass ? " " + elt.htmlClass : "" %>' +
					'<%= (node.schemaElement && node.schemaElement.required && (node.schemaElement.type !== "boolean") ? " jsonform-required" : "") %>' +
					'<%= (node.readOnly ? " jsonform-readonly" : "") %>' +
					'<%= (node.disabled ? " jsonform-disabled" : "") %>' +
					'">' +
					'<% if (node.title && !elt.notitle) { %>' +
					'<label class="control-label" for="<%= node.id %>"><%= node.title %></label>' +
					'<% } %>' +
					'<div class="controls">' +
					'<label class="checkbox container"><%= node.description || "" %><input type="checkbox" id="<%= id %>" ' +
					'name="<%= node.name %>" value="1" <% if (value) {%>checked<% } %>' +
					'<%= (node.disabled? " disabled" : "")%>' +
					'<%= (node.schemaElement && node.schemaElement.required && (node.schemaElement.type !== "boolean") ? " required=\'required\'" : "") %>' +
					' /><span class="checkmark"></span>' +
					'</label>' +
					'<span class="help-block jsonform-errortext" style="display:none;"></span>' +
					'</div></div>',
				fieldtemplate: false,
				inputfield: true,
				getElement: function (el) {
					return $(el).parent().get(0);
				},
				//onBeforeRender: function (data, node) {}
			},
			range: {
				template: '<input type="text" ' +
				'<%= (fieldHtmlClass ? "class=\'" + fieldHtmlClass + "\' " : "") %>' +
				'name="<%= node.name %>" value="<%= escape(value) %>" id="<%= id %>"<%= (node.disabled? " disabled" : "")%>' +
				'<%= (node.schemaElement && node.schemaElement.required ? " required=\'required\'" : "") %>' +
				' data-min="<%= range.min %>" data-max="<%= range.max %>" data-from="<%= range.from %>" data-to="<%= range.to %>"' +
				' data-type="<%= range.type %>" data-prefix="<%= range.prefix %>" data-grid="<%= range.grid %>" data-grid-num="<%= range.gridNum %>"/>',
				fieldtemplate: true,
				inputfield: true,
				onBeforeRender: function (data, node) {
					var values = (data.value) ? data.value.split(';') : [data.schema.minimum];
					data.range = { // Defaults
						min: parseInt(data.schema.minimum),
						max: parseInt(data.schema.maximum),
						from: (values[0]) ? values[0] : parseInt(data.schema.minimum), //(values[1]) ? values[0] : data.schema.minimum,
						to: (values[1]) ? (values[1]) : parseInt(data.schema.minimum) + Math.round((parseInt(data.schema.maximum) - parseInt(data.schema.minimum))/2), //(values[1]) ? values[1] : values[0],
						type: 'double', //(values[1]) ? 'double' : 'single',
						prefix: '',
						grid: true,
						gridNum: 1
					};
					if (!node || !node.schemaElement) return;
					if (node.formElement && node.formElement.step) {
						data.range.step = node.formElement.step;
					}

					//var md = require('markdown-it')();
					//node.title = md.render(node.title);
					//node.description = (node.description!=null) ? md.render(node.description) : 'non ce';
				},
				onInsert: function (evt, node) {
					$('#'+node.id).ionRangeSlider();
				}
			},
			likert: {
				template: '<div class="form-group jsonform-error-<%= keydash %>' +
				'<%= elt.htmlClass ? " " + elt.htmlClass : "" %>' +
				'<%= (node.schemaElement && node.schemaElement.required && (node.schemaElement.type !== "boolean") ? " jsonform-required" : "") %>' +
				'<%= (node.readOnly ? " jsonform-readonly" : "") %><%= (node.disabled ? " jsonform-disabled" : "") %>">' +
				'<% if (!elt.notitle) { %><label for="<%= node.id %>"><%= node.title ? node.title : node.name %></label><% } %>' +
				'<div class="controls">' +
				'<% if (node.prepend || node.append) { %>' +
				'<div class="<% if (node.prepend) { %>input-group<% } %>' +
				'<% if (node.append) { %> input-group<% } %>">' +
				'<% if (node.prepend) { %>' +
				'<span class="input-group-addon"><%= node.prepend %></span>' +
				'<% } %>' +
				'<% } %>' +
				'<select name="<%= node.name %>" id="<%= id %>"' +
				'class="form-control<%= (fieldHtmlClass ? " " + fieldHtmlClass : "") %>"' +
				'<%= (node.disabled? " disabled" : "")%>' +
				'<%= (node.schemaElement && node.schemaElement.required ? " required=\'required\'" : "") %>' +
				'> ' +
				'<% _.each(node.options, function(key, val) { if(key instanceof Object) { if (value === key.value) { %> <option selected value="<%= key.value %>"><%= key.title %></option> <% } else { %> <option value="<%= key.value %>"><%= key.title %></option> <% }} else { if (value === key) { %> <option selected value="<%= key %>"><%= key %></option> <% } else { %><option value="<%= key %>"><%= key %></option> <% }}}); %> ' +
				'</select>'+
				'<% if (node.append) { %>' +
				'<span class="input-group-addon"><%= node.append %></span>' +
				'<% } %>' +
				'<% if (node.prepend || node.append) { %>' +
				'</div>' +
				'<% } %>' +
				'<span class="help-block jsonform-errortext" style="display:none;"></span>' +
				'</div>'+
				'<% if (node.description) { %>' +
				'<span class="help-block"><%= node.description %></span>' +
				'<% } %>' +
				'</div>',
				fieldtemplate: false,
				inputfield: true,
				onInsert: function (evt, node) {
					$('#'+node.id).closest('.controls').addClass('br-box');
					$('#'+node.id).barrating({
						theme: 'likert'
					});
				},
				//onBeforeRender: function (data, node) {}
			},
			stars: {
				template: '<div class="form-group jsonform-error-<%= keydash %>' +
				'<%= elt.htmlClass ? " " + elt.htmlClass : "" %>' +
				'<%= (node.schemaElement && node.schemaElement.required && (node.schemaElement.type !== "boolean") ? " jsonform-required" : "") %>' +
				'<%= (node.readOnly ? " jsonform-readonly" : "") %><%= (node.disabled ? " jsonform-disabled" : "") %>">' +
				'<% if (!elt.notitle) { %><label for="<%= node.id %>"><%= node.title ? node.title : node.name %></label><% } %>' +
				'<div class="controls">' +
				'<% if (node.prepend || node.append) { %>' +
				'<div class="<% if (node.prepend) { %>input-group<% } %>' +
				'<% if (node.append) { %> input-group<% } %>">' +
				'<% if (node.prepend) { %><span class="input-group-addon"><%= node.prepend %></span><% } %>' +
				'<% } %>' +
				'<select name="<%= node.name %>" id="<%= id %>" ' +
				'class="form-control<%= (fieldHtmlClass ? " " + fieldHtmlClass : "") %>"' +
				'<%= (node.disabled? " disabled" : "")%>' +
				'<%= (node.schemaElement && node.schemaElement.required ? " required=\'required\'" : "") %>' +
				'> ' +
				'<% _.each(node.options, function(key, val) { if(key instanceof Object) { if (value === key.value) { %> <option selected value="<%= key.value %>"><%= key.title %></option> <% } else { %> <option value="<%= key.value %>"><%= key.title %></option> <% }} else { if (value === key) { %> <option selected value="<%= key %>"><%= key %></option> <% } else { %><option value="<%= key %>"><%= key %></option> <% }}}); %> ' +
				'</select>' +
				'<% if (node.append) { %><span class="input-group-addon"><%= node.append %></span><% } %>' +
				'<% if (node.prepend || node.append) { %>' +
				'</div>' +
				'<% } %>' +
				'<span class="help-block jsonform-errortext" style="display:none;"></span>' +
				'</div>'+
				'<% if (node.description) { %><span class="help-block"><%= node.description %></span><% } %>' +
				'</div>',
				fieldtemplate: false,
				inputfield: true,
				onInsert: function (evt, node) {
					$('#'+node.id).closest('.controls').addClass('br-box');
					$('#'+node.id).barrating({
						theme: 'stars'
					});
				},
				//onBeforeRender: function (data, node) {}
			},
			checks: {
				template: '<input type="text" ' +
				'class=\'form-control<%= (fieldHtmlClass ? " " + fieldHtmlClass : "") %>\'' +
				'name="<%= node.name %>" value="<%= escape(value) %>" id="<%= id %>"' +
				'<%= (node.disabled? " disabled" : "")%>' +
				'<%= (node.schemaElement && node.schemaElement.required ? " required=\'required\'" : "") %>' +
				'<%= (node.placeholder? " placeholder=" + \'"\' + escape(node.placeholder) + \'"\' : "")%>' +
				' />',
				fieldtemplate: true,
				inputfield: true,
				onInsert: function (evt, node) {
					// Sets Selectize common settings
					var settings = {
						plugins: ['remove_button', 'drag_drop'],
						delimiter: ',',
						create: false,
						persist: false,
						options:  node.schemaElement.items.enum.map(function(value){
							return { text: value, value: value }
						}),
					};
					// Sets Selectize specific settings
					if (node.schemaElement.linked) {
						settings.options = buildOptionsFrom(node.schemaElement.linked);
						settings.render = {
							option: parseLinkedOption
						};
					};
					// Initializes Selectize
					$('#'+node.id).selectize(settings);
				}
			},
			options: {
				template: '<select name="<%= node.name %>" id="<%= id %>"' +
				'<%= (fieldHtmlClass ? " class=\'" + fieldHtmlClass + "\'" : "") %>' +
				'<%= (node.disabled? " disabled" : "")%>' +
				'<%= (node.schemaElement && node.schemaElement.required ? " required=\'required\'" : "") %>' +
				' placeholder="Seleccione una opción..."><option value="">Seleccione una opción...</option>' +
				'<% _.each(node.options, function(key, val) { if(key instanceof Object) { '+
				'if (value === key.value) { %> <option selected value="<%= key.value %>"><%= key.title %></option> <% } else { %> <option value="<%= key.value %>"><%= key.title %></option> <% }'+
				'} else { if (value === key) { %> <option selected value="<%= key %>"><%= key %></option> <% } else { %><option value="<%= key %>"><%= key %></option> <% }}}); %> ' +
				'</select>',
				fieldtemplate: true,
				inputfield: true,
				onInsert: function (evt, node) {
					// Sets Selectize common settings
					var settings = {
						plugins: ['remove_button'],
						options: [],
						items: [node.value],
						create: false,
						maxItems: 2,
						closeAfterSelect: true,
						onItemAdd: function(value, $item) {
							if (this.items.length>1) this.removeItem(this.items[0]);
							//this.addItem(value);
						}
					};
					// Sets Selectize specific settings
					if (node.schemaElement.linked) {
						settings.options = buildOptionsFrom(node.schemaElement.linked);
						settings.render = {
							option: parseLinkedOption
						};
					};
					// Initializes Selectize
					$('#'+node.id).selectize(settings);
				},
			},
			upload: {
				template: '<div id="<%= id %>" class="form-group upload-container"><div class="panel panel-default img-upload">\
					<div class="panel-heading upload-header<%= (node.value!="" && node.value!=undefined ? " hide" : "") %>"><ul class="nav nav-pills">\
						<li class="img-url-btn" style="margin-left: 0px!important;">\
							<a class="form-control" href="javascript:;"><i class="fa fa-external-link" aria-hidden="true"></i>&nbsp;[[picapp:composer.upload_URL_btn]]</a>\
						</li>\
						<li class="img-file-btn">\
							<a class="form-control" href="javascript:;"><i class="fa fa-photo" aria-hidden="true"></i>&nbsp;[[picapp:composer.upload_file_btn]]</a>\
						</li>\
					</ul></div>\
					<div class="panel-body upload-file hide"><div><label for="upload-file-<%= node.name %>" class="input-group-btn">\
						<span class="btn btn-primary btn-file img-select-btn pull-right">\
						<span><i class="fa fa-upload" aria-hidden="true"></i>&nbsp;[[picapp:composer.upload_browse_btn]]</span>\
						<input type="file" id="upload-file-<%= node.name %>" accept="<%= node.schemaElement.mime %>" class="form-control" style="display: none;">\
						</span></label></div></div>\
					<div class="panel-body upload-url hide"><div class="input-group"><div class="form-group has-feedback">\
						<input type="text" name="<%= node.name %>" id="upload-url-<%= node.name %>" data-id="<%= id %>" data-label="<%= node.name %>" class="form-control<%= (fieldHtmlClass ? " " + fieldHtmlClass : "") %> hasclear" placeholder="[[picapp:composer.upload_url_placeholder]]" value="<%= node.value %>">\
						<span class="clearer form-control-feedback"><i class="fa fa-times" aria-hidden="true"></i></span>\
					</div>\
					<span class="input-group-btn">\
					<span class="btn btn-primary img-select-btn" title="[[picapp:composer.upload_submit_btn]]"><i class="fa fa-save" aria-hidden="true"></i><span class="hidden-xs">&nbsp;&nbsp;[[picapp:composer.upload_submit_btn]]</span></span>\
					</span></div></div>\
					<div class="upload-image-loader hide"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div>\
					</div></div></div>',
				fieldtemplate: true,
				inputfield: true,
				getElement: function (el) {
					$(el).translateHtml($(el).html());
					return $(el).parent().get(0);
				},
				'onChange_': function(evt, elt) {
					var target = evt.target;
					var $container = $(target).closest('.upload-container');

					if ($container.data('bound')) {
						return false;
					} else {
						$container.data('bound', true);
					}

					if (target.files && target.files.length) {
						if (window.FormData) {
							var formData = new FormData();
							for (var i = 0; i < target.files.length; ++i) {
								formData.append('files[]', target.files[i], target.files[i].name);
							}
							require(['editor'], function(editor) {
								editor.imageUploaderHandlers('#'+$container.attr('id'), '/api/post/upload');
							})
						} else {
							app.alertError('Operación no soportada por tu navegador');
						}
					}
				},
				'onInsert_': function (evt, node) {
					var $container = $('#'+node.id),
						fileSelector = 'input#'+$container.find('input[type="file"]').attr('id'),
						urlSelector = 'input#'+$container.find('input[type="text"]').attr('id'),
						urlClearer =  1;

					$container
					.on('focus blur', 'img', function(e) {
						var $cnt = $(e.target).closest('.upload-container');
							$cnt.find('.upload-edit-btn, .img-upload').toggleClass('focused', e.type=='focus');
					})
					.on('keyup paste focus', urlSelector, function () {
						$(this).next('span').toggle(Boolean(this.value));
					})
					.on('click', 'li.img-file-btn a', function(e) {
						var $cnt = $(e.target).closest('.upload-container');
						$(e.currentTarget).addClass('active');
						$cnt.find('li.img-url-btn').removeClass('active');
						$cnt.find('.panel-body.upload-file').removeClass('hide');
						$cnt.find('.panel-body.upload-url').addClass('hide');
					})
					.on('click', 'li.img-url-btn a', function(e) {
						var $cnt = $(e.target).closest('.upload-container');
						$(e.currentTarget).addClass('active');
						$cnt.find('li.img-file-btn').removeClass('active');
						$cnt.find('.panel-body.upload-url').removeClass('hide');
						$cnt.find('.panel-body.upload-file').addClass('hide');
					})
					.on('click', '.upload-edit-btn', function(e) {
						var $cnt = $(e.target).closest('.upload-container'),
							$el = $cnt.find(fileSelector);
						$el.wrap('<form />').closest('form').get(0).reset();
						$el.unwrap();

						$cnt.find('.panel-heading.upload-header').removeClass('hide');
						//$cnt.find('.img-wrap').remove();
						$cnt.find(urlSelector).val('').trigger('change');

						$cnt.data('bound', false);
						
						e.preventDefault();
					})
					.on('click', '.panel-body.upload-url .img-select-btn', function(e) {
						require(['editor'], function(editor) {
							editor.refreshUploaderThumb($(e.target).closest('.upload-container')); // CHECK
						});
					})
					.on('click', '.form-control-feedback.clearer', function (e) {
						$(this).prev('input').val('');
						if ($(e.delegateTarget).find('.img-title').hasClass('hide')) {
							$(e.delegateTarget).find('.panel-body.upload-url').addClass('hide');
						} else {
							$(this).prev('input').focus();
						};
						$(this).hide();
					});

					//$container.find('.clearer').hide($(this).prev('input').val());
				},
				'onSubmit':function(evt, elt) {
					//console.log('onSubmit', evt, elt); // DEBUG
					return true;
				},
				//onBeforeRender: function (data, node) {},
			}
		},
		PIC: {
				imageHtmlWrapper: imageHtmlWrapper,
				getIcon: getIcon,
		}
	});
	
	function buildOptionsFrom(linked) {
		// global:  L, app.map.FL, ajaxify, utils
		var options = [];
		if (linked=='map') {
			// Builds options from map features
			var fg = (ajaxify.data.isMain ? app.composerMap._drawLayer : app.composerMap._baseLayer);
			fg.eachLayer(function(layer) {
				if (layer.feature.properties && layer.feature.properties.label && layer.feature.properties.label.length) {
					var coordinates = (layer.feature.properties.centroid ? layer.feature.properties.centroid[1] + ','+ layer.feature.properties.centroid[0] : layer.feature.geometry.coordinates[1] + ','+ layer.feature.geometry.coordinates[0]);
					options.push({
						text: layer.feature.properties.label,
						value: layer.feature.properties.ID,// || layer._leaflet_id,
						image: layer.feature.properties.image || '/plugins/nodebb-plugin-picapp/images/image-placeholder.png',
						coordinates: coordinates,
						area: layer.feature.properties.measure && layer.feature.properties.measure.units==2 ? L.GeometryUtil.readableArea(layer.feature.properties.measure.value, true) : null,
						length: layer.feature.properties.measure && layer.feature.properties.measure.units==1 ? L.GeometryUtil.readableDistance(layer.feature.properties.measure.value, true) : null
					});
				};
			});
		} else if (linked=='gallery') {
			// Builds options from gallery images
			$.each($('#galleryForm input[type="text"'), function(i, o) {
				var label = $(o.closest('.upload-container')).find('.img-title > input').val().trim();
				if (o.value.trim()!='' && o.getAttribute('data-id') && label!='') options.push({
					text: label,
					value: o.getAttribute('data-id'),
					image: o.value.trim()
				});
			});
		}
		return options;
	};

	function parseLinkedOption(item, escape) {
		var data = {
			area: item.area,
			length: item.length,
			coordinates: item.coordinates,
			image: item.image,
			text: item.text,
			value: item.value
		};
		return _.template(JSONForm.PIC.templates.galleryItem)(data);
	}

	function imageHtmlWrapper(src) {
		var imgWrapper = '<div class="img-wrap animate__animated animate__zoomIn">\
			<span class="upload-edit-btn"><i class="fa fa-pencil" title="[[picapp:composer.upload_edit_btn]]"></i></span>\
			<img src="' + ( src==undefined ? '<%= JSONForm.PIC.getIcon(node.value) %>' : getIcon(src) ) + '" \
			class="upload-preview" alt="[[picapp:composer.feature_title]]" title="' + (src==undefined ? '<%= node.value %>' : src) +'" tabindex="0"></div>';
		return imgWrapper;
	}

	function getIcon(src) {
		var fileExtension = utils.fileExtension(src);
		switch (fileExtension) {
			case 'pdf':
				return '/plugins/nodebb-plugin-picapp/images/pdf-icon.png';
			case 'doc':
			case 'docx':
			case 'odt':
			case 'txt':
				return '/plugins/nodebb-plugin-picapp/images/doc-file.png';
			case 'xls':
			case 'xlsx':
			case 'ods':
				return '/plugins/nodebb-plugin-picapp/images/sheet-file.png';
			case 'png':
			case 'jpg':
			case 'jpeg':
			case '':
				return src;
			default:
				return '/plugins/nodebb-plugin-picapp/images/link-icon.png';
		}
	}
	
})(jQuery);
